import React, { useState } from 'react';
import {
  Table,
  Button,
  Input,
  Select,
  Popconfirm,
  Space,
  Card,
  DatePicker,
} from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { getSearchApi } from '../../../network/itemList';
const EducationList = ({
  setDataSourceEduction,
  dataSourceEduction,
  t,
  form,
}) => {
  console.log(dataSourceEduction, 'dataSourceEduction');

  const [count, setCount] = useState(0);
  const columns = [
    {
      title: t.schoolUniv,
      dataIndex: 'school_univ',
      render: (text, record, index) => (
        <Input
          placeholder={t.schoolUniv}
          style={{ width: '100%' }}
          value={record.school_univ}
          onChange={(e) => {
            const newDataSource = [...dataSourceEduction];
            newDataSource[index] = {
              ...newDataSource[index],
              school_univ: e.target.value,
            };
            setDataSourceEduction(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.qualification,
      dataIndex: 'qualification',
      render: (text, record, index) => (
        <Input
          placeholder={t.qualification}
          style={{ width: '100%' }}
          value={record.qualification}
          onChange={(e) => {
            const newDataSource = [...dataSourceEduction];
            newDataSource[index] = {
              ...newDataSource[index],
              qualification: e.target.value,
            };
            setDataSourceEduction(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.level,
      dataIndex: 'level',
      render: (text, record, index) => (
        <Select
          placeholder={t.level}
          style={{ width: '100%' }}
          value={record.level}
          onChange={(e) => {
            const newDataSource = [...dataSourceEduction];
            newDataSource[index] = {
              ...newDataSource[index],
              level: e,
            };
            setDataSourceEduction(newDataSource);
          }}
        >
          <Select.Option value="Graduate">{t.Graduate}</Select.Option>
          <Select.Option value="Post Graduate">{t.PostGraduate}</Select.Option>
        </Select>
      ),
    },
    {
      title: t.yearOfPassing,
      dataIndex: 'year_of_passing',
      render: (text, record, index) => (
        <DatePicker
          placeholder={t.yearOfPassing}
          // format="YYYY"
          picker="year"
          style={{ width: '100%' }}
          value={dayjs(record.year_of_passing)}
          onChange={(e, value) => {
            const newDataSource = [...dataSourceEduction];
            newDataSource[index] = {
              ...newDataSource[index],
              year_of_passing: dayjs(value).format('YYYY'),
            };
            setDataSourceEduction(newDataSource);
          }}
        />
      ),
    },

    {
      title: t.action,
      key: 'action',
      render: (text, record, index) => (
        <Space>
          <Popconfirm
            title={t.confirmDelete}
            onConfirm={() => handleDelete(record.key)}
          >
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              size="small"
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleAdd = () => {
    const newData = {
      key: count,
      year_of_passing: dayjs(),
    };
    setDataSourceEduction([...dataSourceEduction, newData]);
    setCount(count + 1);
  };

  const handleDelete = (key) => {
    const newDataSource = dataSourceEduction.filter((item) => item.key !== key);
    setDataSourceEduction(newDataSource);
  };

  return (
    <Card>
      <Table
        className="table_custom"
        dataSource={dataSourceEduction}
        columns={columns}
        pagination={{
          hideOnSinglePage: true,
        }}
        scroll={{ x: 'max-content' }}
        // className="table"
        rowKey="key"
      />
      <Button
        onClick={handleAdd}
        type="primary"
        ghost
        style={{ marginTop: '20px', borderRadius: '6px' }}
        icon={<PlusOutlined />}
        size="small"
      >
        {t.addRow}
      </Button>
    </Card>
  );
};

export default EducationList;
